import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback  } from 'react';
import { useLocation } from 'react-router-dom';            // add useLocation
import BottomNav from './BottomNav';                        // new import
import { useAuth } from '../../context/AuthContext';
import { notificationsAPI } from '../../api';
import { ProfileModal } from '../setup/SetupPage';
import { useTheme } from '../../context/ThemeContext';
import toast from 'react-hot-toast';
import styles from './Layout.module.css';
import logo from "../../starLogo.png";
import grettingicon from "../../sun-icon.png";
import { usePermission } from '../../context/PermissionContext';
/* import  './LAYOUT_PATCH.js'; */
const hour        = new Date().getHours();
const greeting    = hour<12?'Morning':hour<17?'Afternoon':'Evening';

const Icons = {
  Dashboard:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  Assets:      () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>,
  ImportExport:() => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/><path d="M3 9v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9"/></svg>,
  FinYear:     () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/></svg>,
  FinImport:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 2v10m0 0l-3-3m3 3l3-3"/><rect x="2" y="14" width="20" height="8" rx="2"/><path d="M6 18h.01M10 18h2"/></svg>,
  LabelPrint:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h.01M18 14h.01M14 18h.01M18 18h.01"/></svg>,
  WorkOrders:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
  Maintenance: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Spares:      () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
  Compliance:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Reports:     () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  Audit:       () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  Settings:    () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  Setup:       () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
  iPurchase:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>,
  iChats:      () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  iEvents:     () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  iIncidents:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
/*   iSupplyLink: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>, */
  Vendors: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
  <polyline points="9 22 9 12 15 12 15 22"/>
</svg>,
};

const NAV = [
  {
    section: 'Overview',
    items: [
      {
        to: '/dashboard',
        icon: 'Dashboard',
        label: 'Dashboard',
        module: 'dashboard',
      },
    ],
  },

  {
    section: 'Asset Management',
    items: [
      {
        to: '/assets',
        icon: 'Assets',
        label: 'Assets',
        module: 'assets',
      },     
      {
        to: '/work-orders',
        icon: 'WorkOrders',
        label: 'Work Orders',
        module: 'work_orders',
      },
      {
        to: '/maintenance',
        icon: 'Maintenance',
        label: 'Maintenance',
        module: 'work_orders',
      },
      {
        to: '/spares',
        icon: 'Spares',
        label: 'Spare Parts',
        module: 'spares',
      },
    ],
  },

  {
    section: 'Procurement',
    items: [
      {
        to: '/vendors',
        icon: 'Vendors',
        label: 'Vendors',
        module: 'vendors',
      },      
    ],
  },

  {
    section: 'Administration',
    items: [
      {
        to: '/settings',
        icon: 'Settings',
        label: 'Settings',
        module: 'setup',
      },
      {
        to: '/setup',
        icon: 'Setup',
        label: 'Setup',
        module: 'setup',
      },
    ],
  },
  {
    section: 'Import-Export Facility',
    items: [       
      {
        to: '/assets/import-export',
        icon: 'ImportExport',
        label: 'Asset Import / Export',
        module: 'assets',
      },
      {
        to: '/assets/financial-year-review',
        icon: 'FinYear',
        label: 'FY Review',
        module: 'assets',
      },
      {
        to: '/vendors/import-export',
        icon: 'ImportExport',
        label: 'Vendor Import / Export',
        module: 'vendors',
      },
       {
        to: '/assets/label-print',
        icon: 'LabelPrint',
        label: 'Label Print',
        module: 'assets',
      },
    ],
  },
];

export default function Layout() {
  const { user, logout, setUser } = useAuth();
  const { loadTheme } = useTheme();
  const navigate    = useNavigate();
  const [notifOpen,     setNotifOpen]     = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unread,        setUnread]        = useState(0);
  const [search,        setSearch]        = useState('');
  const [collapsed,     setCollapsed]     = useState(false);
  const [profileDrop,   setProfileDrop]   = useState(false);
  const [profileMode,   setProfileMode]   = useState(null); // 'view' | 'edit' | 'password'
  const profileRef = useRef();
  const { canView } = usePermission();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    notificationsAPI.list()
      .then(r => { setNotifications(r.data.data); setUnread(r.data.unread_count); })
      .catch(() => {});
  }, []);

  // Close profile dropdown on outside click
  useEffect(() => {
    const h = e => { if (profileRef.current && !profileRef.current.contains(e.target)) setProfileDrop(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  // Load org theme from server on mount
  useEffect(() => { if (user) loadTheme(); }, [user]);

  //------------ mobile related changes 
  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) { setMenuOpen(false); document.body.classList.remove('ia-menu-open'); }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Sync body class so CSS can show/hide overlay
  useEffect(() => {
    document.body.classList.toggle('ia-menu-open', menuOpen);
    return () => document.body.classList.remove('ia-menu-open');
  }, [menuOpen]);

  // Auto-close sidebar on route change (mobile)
  useEffect(() => {
    if (isMobile) setMenuOpen(false);
  }, [location.pathname, isMobile]);

  const closeMobileMenu = useCallback(() => {
    if (isMobile) setMenuOpen(false);
  }, [isMobile]);
  //---------------- mobile related changes end

  const handleMarkRead = async () => {
    await notificationsAPI.markRead();
    setUnread(0);
    setNotifications(n => n.map(x => ({ ...x, is_read: true })));
  };

  const handleLogout = async () => {
    setProfileDrop(false);
    await logout();
    navigate('/login');
    toast.success('Signed out successfully');
  };

  const handleSearch = e => {
    if (e.key === 'Enter' && search.trim()) {
      navigate(`/assets?q=${encodeURIComponent(search)}`);
      setSearch('');
    }
  };

  const handleProfileSave = form => {
    const updated = { ...user, ...form };
    setUser(updated);
    localStorage.setItem('iassets_user', JSON.stringify(updated));
    toast.success('Profile updated');
    setProfileMode(null);
  };

  const initials  = user?.name?.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'U';
  const IMG_BASE  = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace('/api', '');
  const avatarSrc = user?.avatar ? `${IMG_BASE}/uploads/avatars/${user.avatar}` : null;

  return (
    <div className={styles.shell}>
      {/* ── Sidebar ── */}
      <aside className={`${styles.sidebar} ${collapsed ? styles.sidebar_collapsed : ''}`}>
        <div className={styles.logo}>
        <img src={logo} alt="iAssets Logo" className={styles.logo_image} />
          {!collapsed && <span className={styles.logo_text}>i <span>Asset</span></span>}
          <button className={styles.collapse_btn} onClick={() => setCollapsed(c => !c)} title={collapsed ? 'Expand' : 'Collapse'}>
            {collapsed ? '›' : '‹'}
          </button>
        </div>

       {/*  {!collapsed && (
          <div className={styles.org_box}>
            <div>
              <div className={styles.org_name}>{user?.org_name || 'Organisation'}</div>
              <div className={styles.org_sub}>{user?.role_name}</div>
            </div>
            <span className={styles.org_chevron}>⌄</span>
          </div>
        )} */}

        <nav className={styles.nav}>
        {NAV.map(section => {
  const visibleItems = section.items.filter(item =>
    canView(item.module)
  );

  if (visibleItems.length === 0) return null;

  return (
    <div key={section.section}>
      {!collapsed && (
        <div className={styles.nav_section}>
          {section.section}
        </div>
      )}

      {visibleItems.map(item => {
        const IconComp = Icons[item.icon];

        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `${styles.nav_item} ${
                isActive ? styles.nav_active : ''
              } ${
                collapsed ? styles.nav_item_collapsed : ''
              }`
            }
            title={collapsed ? item.label : undefined}
          >
            <span className={styles.nav_icon}>
              {IconComp ? <IconComp /> : item.label[0]}
            </span>

            {collapsed ? (
              <span className={styles.nav_label_collapsed}>
                {item.label}
              </span>
            ) : (
              <span className={styles.nav_label}>
                {item.label}
              </span>
            )}
          </NavLink>
        );
      })}
    </div>
  );
})}
        </nav>

        <div className={styles.sidebar_footer}>
          <div className={styles.avatar}>
              {avatarSrc
                ? <img src={avatarSrc} alt="avatar" style={{width:'100%',height:'100%',borderRadius:'50%',objectFit:'cover'}}/>
                : initials}
            </div>
          {!collapsed && (
            <div className={styles.avatar_info}>
              <div className={styles.avatar_name}>{user?.name}</div>
              <div className={styles.avatar_role}>{user?.department || user?.role_slug}</div>
            </div>
          )}
          <button className={styles.logout_btn} onClick={handleLogout} title="Sign Out">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className={styles.main}>
        {/* Topbar */}
        <header className={styles.topbar}>
          <div className={styles.search_box}>
            <span className={styles.search_icon}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input
              type="text"
              placeholder="Search assets, work orders…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={handleSearch}
            />
          </div>
         
          <div className={styles.topbar_actions}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', padding:'7px 20px', background:'#4c761b', borderBottom:'0px solid #e2e8f0', gap:14, flexShrink:0 }}>
          <span style={{ fontSize:13, color:'white',marginBottom:'4px' }}><img src={grettingicon} alt="iAssets Logo" className={styles.greeting_image} /> Good {greeting}</span>
          <span style={{ fontSize:13, color:'white', fontFamily:'monospace' }}>
            {new Date().toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' })}
          </span>
          </div>
            <NavLink to="/assets/new" className={styles.icon_btn} title="Add Asset">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </NavLink>

            {/* Notifications */}
            <div className={styles.notif_wrap}>
              <button className={styles.icon_btn} onClick={() => setNotifOpen(o => !o)} title="Notifications">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
                {unread > 0 && <span className={styles.notif_dot}>{unread > 9 ? '9+' : unread}</span>}
              </button>
              {notifOpen && (
                <div className={styles.notif_panel}>
                  <div className={styles.notif_header}>
                    Notifications
                    <button className={styles.notif_mark_read} onClick={handleMarkRead}>Mark all read</button>
                  </div>
                  <div className={styles.notif_list}>
                    {notifications.length === 0
                      ? <div className={styles.notif_empty}>All caught up! 🎉</div>
                      : notifications.map(n => (
                          <div key={n.id} className={`${styles.notif_item} ${!n.is_read ? styles.notif_unread : ''}`}>
                            {!n.is_read && <div className={styles.notif_unread_dot} />}
                            <div>
                              <div className={styles.notif_text}>{n.title}</div>
                              <div className={styles.notif_time}>{n.message}</div>
                            </div>
                          </div>
                        ))
                    }
                  </div>
                </div>
              )}
            </div>

            {/* ── Profile avatar with dropdown ── */}
            <div ref={profileRef} style={{ position: 'relative' }}>
              <div
                className={styles.topbar_avatar}
                onClick={() => setProfileDrop(d => !d)}
                title={user?.name}
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                {avatarSrc
                  ? <img src={avatarSrc} alt="avatar" style={{width:'100%',height:'100%',borderRadius:'50%',objectFit:'cover'}}/>
                  : initials}
              </div>

              {profileDrop && (
                <div style={{
                  position: 'absolute', top: 'calc(100% + 8px)', right: 0,
                  width: 210, background: '#fff',
                  border: '1px solid #e2e8f0', borderRadius: 12,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
                  zIndex: 500, overflow: 'hidden',
                  animation: 'dropIn 0.15s ease',
                }}>
                  {/* User info header */}
                  <div style={{ padding: '14px 16px 10px', borderBottom: '1px solid #f1f5f9' }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#1e2a3b' }}>{user?.name}</div>
                    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{user?.email}</div>
                  </div>

                  {/* My Profile */}
                  <button onClick={() => { setProfileDrop(false); setProfileMode('view'); }} style={dropItemStyle}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    My Profile
                  </button>

                  {/* Edit Profile */}
                  <button onClick={() => { setProfileDrop(false); setProfileMode('edit'); }} style={dropItemStyle}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Edit Profile
                  </button>
 {/* Edit Profile */}
 <button onClick={() => { setProfileDrop(false); setProfileMode('password'); }} style={dropItemStyle}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Change Password
                  </button>

                  <hr style={{ border: 'none', borderTop: '1px solid #f1f5f9', margin: '4px 0' }} />

                  {/* Logout */}
                  <button onClick={handleLogout} style={{ ...dropItemStyle, color: '#ef4444' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Content */}
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>

      {/* Profile modals */}
      {profileMode && (
        <ProfileModal
          user={user}
          mode={profileMode}
          onClose={() => setProfileMode(null)}
          onSave={handleProfileSave}
        />
      )}

      <style>{`
        @keyframes dropIn {
          from { opacity:0; transform:translateY(-6px); }
          to   { opacity:1; transform:none; }
        }
      `}</style>
    </div>
  );

  return (
    <div className={styles.app_wrapper}>

      ╔══ SIDEBAR — add id="ia-sidebar" ══════════════════════╗
      <aside id="ia-sidebar" className={styles.sidebar_bg}>

        ... your logo / brand ...

        ... your nav links — add onClick={closeMobileMenu} to each:
            <Link to="/assets" onClick={closeMobileMenu}>Assets</Link>
            <Link to="/work-orders" onClick={closeMobileMenu}>Work Orders</Link>
            ... etc
        ...

      </aside>
      ╚════════════════════════════════════════════════════════╝

      ╔══ MAIN WRAPPER — add id="ia-main" ════════════════════╗
      <div id="ia-main" className={styles.main_content}>

        ╔══ HEADER — add id="ia-topbar" ══════════════════════╗
        <header id="ia-topbar" className={styles.top_bar}>

          ┌── HAMBURGER BUTTON (shown on mobile via CSS) ──────┐
          <button
            id="ia-hamburger"
            onClick={() => setMenuOpen(m => !m)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span className="bar" />
          </button>
          └───────────────────────────────────────────────────┘

          ... rest of header (logo, search, notifications, avatar) ...

        </header>
        ╚════════════════════════════════════════════════════════╝

        <main className={styles.page_content}>
          <Outlet />
        </main>

        ┌── BOTTOM NAV (CSS shows only on ≤768px) ────────────┐
        <BottomNav />
        └─────────────────────────────────────────────────────┘

      </div>
      ╚════════════════════════════════════════════════════════╝

      ┌── BACKDROP TAP-TO-CLOSE ────────────────────────────── ┐
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{ position:'fixed', inset:0, zIndex:898, background:'transparent' }}
          aria-hidden="true"
        />
      )}
      └──────────────────────────────────────────────────────── ┘

    </div>
  );
}

const dropItemStyle = {
  display: 'flex', alignItems: 'center', gap: 10,
  padding: '10px 16px', fontSize: 13, color: '#4a5568',
  cursor: 'pointer', background: 'none', border: 'none',
  width: '100%', textAlign: 'left', fontFamily: 'inherit',
  transition: 'background 0.12s',
};
